export default {
    data() {
        return {
            fontSize: null,
            messageColour: "",
            parentClass: ".message-wrapper", // Use a reliable default class
        };
    },
    props: {
        message: {}
    },
    methods: {
        getMessageColor() {
            if (this.message.messageColour) {
                return this.message.messageColour;
            }

            switch (this.message.type) {
                case 1:
                    return "#5bc0de"; // info
                case 2:
                    return "#f0ad4e"; // warning
                case 3:
                    return "#d9534f"; // danger
                case 4:
                    return "#5cb85c"; // success
                default:
                    return "";
            }
        },

        resizeText() {
            
                const el = document.getElementById(this.message.noticeMessageId);
                if (!el) return;

                const parent = el.closest(this.parentClass);
                if (!parent) return;

                const maxHeight = parent.offsetHeight;
                const maxFontSize = 120;
                let low = 10;
                let high = maxFontSize;
                let bestFit = 10;

                // Set initial font size
                el.style.fontSize = `${low}px`;

                // Binary search for best fitting font size
                while (low <= high) {
                    const mid = Math.floor((low + high) / 2);
                    el.style.fontSize = `${mid}px`;

                    if (el.offsetHeight <= maxHeight) {
                        bestFit = mid;
                        low = mid + 1;
                    } else {
                        high = mid - 1;
                    }
                }

                el.style.fontSize = `${bestFit}px`;

                if (this.fontSize !== bestFit) {
                    this.fontSize = bestFit;
                }
        }
    },
    created() {
        this.messageColour = this.getMessageColor();
    },
    mounted() {
        this.resizeText();
    },
    updated() {
        this.resizeText();
    }
};
